export default __webpack_public_path__ + "static/media/2024.20bf2d7e.png";